import { SEARCH_RESULTS_REQUEST, SEARCH_RESULTS_SUCCESS, SEARCH_RESULTS_FAILURE } from './types';
import I18n from '../../../config/i18n';
import ApiClient from '../../../utils/ApiClient';

let currentSearch = '';

const requestSearchResults = (lang, search) => ({
  type: SEARCH_RESULTS_REQUEST,
  loading: true,
  lang,
  search,
});

const receiveSearchResults =
  ({ totalPages, results }) =>
  (dispatch) => {
    dispatch({
      type: SEARCH_RESULTS_SUCCESS,
      loading: false,
      totalPages,
      results,
    });
    if (window.scrollTo) {
      window.scrollTo(0, 0);
    }
  };

const failSearchResults = () => ({
  type: SEARCH_RESULTS_FAILURE,
  loading: false,
});

export const fetchSearchResults = (queryString) => (dispatch) => {
  if (currentSearch === queryString) return;
  const lang = I18n.locale;
  currentSearch = queryString;

  dispatch(requestSearchResults(lang, queryString));

  ApiClient.getSearchResults(lang, queryString)
    .then((res) => {
      if (queryString === currentSearch) {
        dispatch(receiveSearchResults(res.data));
      }
    })
    .catch(() => dispatch(failSearchResults()));
};

export default { fetchSearchResults };
